import React, { useEffect } from 'react';
import {
  Box,
  Button,
  Checkbox,
  Grid,
  MenuItem,
  Select,
  Typography,
  List,
  ListItem,
} from '@material-ui/core';
import i18n from 'i18n-js';
import { useState } from 'react';
import PropTypes from 'prop-types';
import { AuthActions } from 'state/modules/auth';
import { useDispatch, useSelector } from 'react-redux';
import MfaModal from 'components/Modals/MfaModal';
import Can from 'components/Can';

const MfaTab = ({ classes }) => {
  const MFA_OPTIONS = { REQUIRED: 'required', DISABLED: 'disabled' };
  const selected_option_default = MFA_OPTIONS.DISABLED;
  const dispatch = useDispatch();
  const [openDialog, setOpenDialog] = useState(false);
  const [isEmailChecked, setIsEmailChecked] = useState(true);
  const [currentOption, setCurrentOption] = useState(selected_option_default);
  const [optionSelected, setOptionSelected] = useState(selected_option_default);

  useEffect(() => {
    dispatch(AuthActions.fetchTwoFactorConfiguration());
  }, [dispatch]);

  const { twoFactorConfiguration } = useSelector((state) => state.auth);

  useEffect(() => {
    if (twoFactorConfiguration && twoFactorConfiguration.email)
      setIsEmailChecked(twoFactorConfiguration.email);

    if (twoFactorConfiguration && twoFactorConfiguration.login_policy) {
      const loginPolicy = twoFactorConfiguration.login_policy.toLowerCase();
      setCurrentOption(loginPolicy);
      setOptionSelected(loginPolicy);
    }
  }, [twoFactorConfiguration]);

  const onConfirm = () => {
    dispatch(
      AuthActions.setTwoFactorConfiguration({
        login_policy: optionSelected.toUpperCase(),
        email: isEmailChecked,
      })
    );
    setOpenDialog(false);
  };

  const dialogDescription = () => {
    const key =
      optionSelected == MFA_OPTIONS.REQUIRED
        ? 'authentication.mfa_tab.required_modal_message'
        : 'authentication.mfa_tab.disabled_modal_message';
    return i18n.t(key);
  };

  var descriptionList = [];

  const getDescriptionList = () => {
    const descriptions = i18n.t('authentication.mfa_tab.description');
    descriptionList = Array.isArray(descriptions) ? descriptions : [];
    return descriptionList;
  };

  return (
    <Can I="update" a="mfa">
      <Box
        textAlign="justify"
        flexDirection="column"
        display="flex"
        className={classes.textContainer}
      >
        <Box fontSize={16} component="h5" lineHeight={1}>
          {i18n.t('authentication.mfa_tab.content_title')}
        </Box>
        <Typography color="textPrimary" className={classes.description}>
          <Box fontSize={14} component="span" lineHeight={1}>
            {getDescriptionList().length > 0 && (
              <List className={classes.mfaDescriptionList}>
                {descriptionList.map((text, index) => (
                  <ListItem key={index} className={classes.mfaDescriptionListItem}>
                    {text}
                  </ListItem>
                ))}
              </List>
            )}
          </Box>
        </Typography>
        <Box fontSize={14} className={classes.rowForm}>
          <Checkbox disabled={true} checked={isEmailChecked} className={classes.mfaCheckbox} />{' '}
          {i18n.t('common.email')}
        </Box>
        <Grid container direction="row" justifyContent="center" alignContent="center">
          <Grid item xs={2}>
            <Box fontSize={14} component="h2">
              {i18n.t('authentication.mfa_tab.on_login')}
            </Box>
          </Grid>
          <Grid item xs={10}>
            <Select
              labelId="mfa-method-label"
              data-cy="mfa-method-select"
              id="mfa-method"
              label={i18n.t('authentication.mfa_tab.select_option')}
              value={optionSelected}
              className={classes.selectField}
              onChange={(e) => {
                setOptionSelected(e.target.value);
              }}
              required
              inputProps={{ 'data-testid': 'mfa-method-select' }}
            >
              <MenuItem disabled value="select_option">
                {i18n.t('authentication.mfa_tab.select_option')}
              </MenuItem>
              <MenuItem value={MFA_OPTIONS.DISABLED}>
                {i18n.t('authentication.mfa_tab.disabled_option')}
              </MenuItem>
              <MenuItem value={MFA_OPTIONS.REQUIRED}>
                {i18n.t('authentication.mfa_tab.required_option')}
              </MenuItem>
            </Select>
          </Grid>
        </Grid>
        <Box display="flex" justifyContent="right" mt={5}>
          <Button
            color="primary"
            variant="contained"
            data-cy="edit-btn"
            disabled={optionSelected === currentOption}
            className={classes.editButton}
            onClick={() => setOpenDialog(true)}
          >
            {i18n.t('common.update')}
          </Button>
        </Box>
      </Box>
      <MfaModal
        open={openDialog}
        dialogDescription={dialogDescription()}
        setOpenDialog={setOpenDialog}
        onConfirm={onConfirm}
      />
    </Can>
  );
};

MfaTab.propTypes = {
  classes: PropTypes.shape({
    textContainer: PropTypes.string,
    description: PropTypes.string,
    rowForm: PropTypes.string,
    selectField: PropTypes.string,
    editButton: PropTypes.string,
    dialog: PropTypes.string,
    dialogContainer: PropTypes.string,
    dialogTitle: PropTypes.string,
    dialogDescription: PropTypes.string,
    dialogNote: PropTypes.string,
    dialogButtonRight: PropTypes.string,
    dialogButtonLeft: PropTypes.string,
    checkIcon: PropTypes.string,
    mfaCheckbox: PropTypes.string,
    mfaDescriptionList: PropTypes.string,
    mfaDescriptionListItem: PropTypes.string,
  }).isRequired,
};

export default MfaTab;
